import type { PropsWithChildren, RefObject } from 'react';

import { FormProvider } from '@givebacks/formy/components';
import { useBreakPoints } from 'core/Hooks';
import { Box, Modal, Stack, rem } from 'ui';

import { CheckoutModalCloseButton } from './CheckoutModalCloseButton';

interface CheckoutModalContainerProps extends PropsWithChildren {
  /** is the modal open */
  opened: boolean;
  /** Called when the modal is closed */
  onClose: () => void;
  /** Slots for modals to be rendered outside the modal root */
  modalSlot?: React.ReactNode;
}
const CheckoutModalContainer = ({
  opened,
  onClose,
  children,
  modalSlot,
}: CheckoutModalContainerProps) => {
  const { isMediumScreen } = useBreakPoints();
  return (
    <FormProvider>
      {({ formScrollableRef }) => (
        <Stack>
          <Modal.Root
            opened={opened}
            onClose={onClose}
            closeOnClickOutside={false}
            closeOnEscape={false}
            styles={
              isMediumScreen
                ? {
                    inner: {
                      paddingTop: rem(80),
                      paddingBottom: 0,
                    },
                  }
                : {}
            }
          >
            <Modal.Overlay />
            <CheckoutModalCloseButton onClick={onClose} />
            <Modal.Content
              /** The default transition on the modal causes a transform(XXX) effect on the modal- this will interfere with the absolutely portioned iframe elements in the modal */
              transitionProps={{ transition: 'fade', duration: 250 }}
              p={0}
              radius="md"
              bg="transparent"
              style={{
                boxShadow: 'none',
                overflow: 'scroll',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
              }}
              ref={formScrollableRef as unknown as RefObject<HTMLDivElement>}
            >
              <Modal.Body p={0} maw="750">
                <Box maw="750" p={0}>
                  {children}
                </Box>
              </Modal.Body>
            </Modal.Content>
          </Modal.Root>
          {modalSlot}
        </Stack>
      )}
    </FormProvider>
  );
};
export { CheckoutModalContainer };
